export const formatPhone = (phone: string) => {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');

  if (digits.length <= 10) {
    // fixo
    return digits
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2');
};
